var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teste-fontes"},[_c('h1',[_vm._v("Power stones")]),_c('h2',[_vm._v("Power stones")]),_c('h3',[_vm._v("Power stones")]),_c('h4',[_vm._v("Power stones")]),_c('h5',[_vm._v("Power stones")]),_c('h6',[_vm._v("Power stones")]),_c('p',[_vm._v("Entre nesse universo")]),_c('span',[_vm._v("Entre nesse universo")])])
}]

export { render, staticRenderFns }